/**
 * useTelegramBackButton — wire Telegram native BackButton vào React Router.
 *
 * Mount component → BackButton hiện trên thanh Telegram top.
 * Click BackButton → navigate tới route mặc định (default `/`).
 * Unmount → BackButton hide.
 *
 * No-op khi không chạy trong Telegram Mini App.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { showBackButton } from "../lib/telegram";

export function useTelegramBackButton(fallbackRoute = "/"): void {
  const navigate = useNavigate();

  useEffect(() => {
    const cleanup = showBackButton(() => {
      navigate(fallbackRoute);
    });
    return cleanup;
  }, [navigate, fallbackRoute]);
}
